import store from '../../store';
import Mentor from './mentor';
import Mentee from './mentee';
import Chat from '../../views/Chat.vue';
import EllyEbby from '../../views/EllyEbby.vue';
import TaskDetails from '../../views/TaskDetails.vue';
import ResourceView from '../../views/ResourceView.vue';
import UserProfile from '../../views/user/UserProfile.vue';
import NewUser from '../../views/user/NewUser.vue';
import GroupChat from '../../views/GroupChat.vue';
import MatchEndedSurvey from '../../views/surveys/MatchEndedSurvey.vue';
import ProgramSurveys from '../../views/surveys/ProgramSurveys.vue';
import CreateMeeting from '../../views/CreateMeeting.vue';
import VideoMeeting from '../../views/VideoMeeting.vue';
import MentorshipGroup from '../../views/MentorshipGroup/MentorshipGroup.vue';
import MentorshipGroupTasks from '../../views/MentorshipGroup/MentorshipGroupTasks.vue';
import MentorshipGroupChat from '../../views/MentorshipGroup/MentorshipGroupChat.vue';
import MentorshipGroupProfile from '../../views/MentorshipGroup/MentorshipGroupProfile.vue';
import GroupTaskDetails from '../../views/GroupTaskDetails.vue';
import Expert from '../../views/mentee/Expert.vue';

const userData = store.dispatch('getLoggedInUserData');
const UserRoutes = async () => {
  await userData;
  let User = [];

  if (store.state.user.type) {
    User = store.state.user.type === 3 ? Mentor : Mentee;
  }

  return [{
    path: '/app',
    // name: 'app',
    async component() {
      await userData;
      return store.state.user.type === 3
        ? import('../../views/mentor/MentorApp.vue')
        : import('../../views/mentee/MenteeApp.vue');
    },
    meta: {
      requiresLogin: true,
      requiresUserType: true,
    },
    children: [
      {
        path: '',
        name: 'app',
        async component() {
          await userData;
          return store.state.user.type === 3
            ? import('../../views/mentor/Home.vue')
            : import('../../views/mentee/Home.vue');
        },
        alias: 'default',
        meta: {
          userGuideContext: 'Home',
        },
      },
      {
        path: 'settings',
        name: 'settings',
        async component() {
          await userData;
          return import('../../views/Settings.vue');
        },
      },
      {
        path: 'modules',
        name: 'modules',
        component: () => import('../../views/Modules.vue'),
        meta: {
          userGuideContext: 'Modules',
        },
      },
      {
        path: 'module/:id',
        name: 'module',
        component: () => import('../../views/Module.vue'),
        props: true,
        meta: {
          userGuideContext: 'Modules',
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: UserProfile,
        meta: {
          userGuideContext: 'Profile',
        },
      },
      {
        path: 'resources',
        name: 'resources',
        async component() {
          await userData;
          return store.state.user.type === 3
            ? import('../../views/mentor/Resources.vue')
            : import('../../views/mentee/Resources.vue');
        },
        meta: {
          userGuideContext: 'Resources',
        },
      },
      {
        path: 'new-user',
        alias: 'profile-settings',
        name: 'NewUser',
        component: NewUser,
        meta: {
          userGuideContext: 'New User',
        },
      },
      {
        path: 'elly',
        alias: 'ebby',
        name: 'ellyebby',
        component: EllyEbby,
        props: { lgGrid: true },
        meta: {
          userGuideContext: 'Ebby or Elly',
        },
      },
      {
        path: 'chat/:id',
        name: 'chatView',
        component: Chat,
        props: true,
        meta: {
          userGuideContext: 'Chat',
        },
      },
      {
        path: 'task/:id',
        name: 'FullTaskDetails',
        component: TaskDetails,
        props: true,
        meta: {
          userGuideContext: 'Tasks',
        },
      },
      {
        path: 'resource',
        name: 'ResourceView',
        component: ResourceView,
        props: true,
        meta: {
          userGuideContext: 'Resources',
        },
      },
      {
        path: 'group-chat',
        name: 'GroupChat',
        component: GroupChat,
        props: true,
        meta: {
          userGuideContext: 'Group Chat',
        },
      },
      {
        path: 'surveys/matchended-survey',
        name: 'MatchEndedSurvey',
        component: MatchEndedSurvey,
        props: true,
        meta: {
          userGuideContext: 'Survey',
        },
      },
      {
        path: 'surveys/program-surveys',
        name: 'ProgramSurveys',
        component: ProgramSurveys,
        props: true,
        meta: {
          userGuideContext: 'Survey',
        },
      },
      {
        path: 'session/create-video-meeting',
        name: 'CreateMeeting',
        component: CreateMeeting,
        props: true,
        meta: {
          userGuideContext: 'Video Meeting',
        },
      },
      {
        path: 'session/edit-video-meeting/:id', // will use queries to pre-select users
        name: 'EditMeeting',
        component: CreateMeeting,
        props: true,
        meta: {
          userGuideContext: 'Video Meeting',
        },
      },
      {
        path: 'session/video-meeting/:id',
        name: 'VideoMeeting',
        component: VideoMeeting,
        props: true,
        meta: {
          userGuideContext: 'Video Meeting',
        },
      },
      {
        path: 'mentorship-group/:id',
        name: 'mentorshipGroup',
        component: MentorshipGroup,
        props: true,
        children: [
          {
            path: 'tasks',
            name: 'mentorshipGroupTasks',
            // alias: '',
            component: MentorshipGroupTasks,
          },
          {
            path: 'chat',
            name: 'mentorshipGroupChat',
            component: MentorshipGroupChat,
          },
          {
            path: 'profile',
            name: 'mentorshipGroupProfile',
            component: MentorshipGroupProfile,
          },
        ],
        meta: {
          userGuideContext: 'Mentorship Groups',
        },
      },
      {
        path: 'group-task/:id',
        name: 'FullGroupTaskDetails',
        component: GroupTaskDetails,
        props: true,
        meta: {
          userGuideContext: 'Group Tasks',
        },
      },
      {
        path: 'expert/:id',
        name: 'ExpertView',
        component: Expert,
        props(route) {
          return {
            id: route.params.id,
            prevRoute: {
              name: store.state.user.type === 3 ? 'mentorMenteesView' : 'menteeMentorsView',
            },
          };
        },
        meta: {
          userGuideContext: 'Experts',
        },
      },
      ...User,
    ],
  }];
};

export default UserRoutes;
